// extracted by mini-css-extract-plugin
module.exports = {"themeColorDark":"#00122a","themeColorLight":"#001e46"};